import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: '[roof-type-9]',
    templateUrl: './roof-type-9.component.html',
    styleUrl: './roof-type-9.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RoofType9Component {
}
